import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box } from '@mui/material';
import { ConnectorModel } from '@/lib/models/connector/connector.model';

interface Props {
  formHandle: FormHandle<ConnectorModel>;
  mode: ViewMode;
}

const TailscaleConnector: FC<Props> = ({ formHandle, mode }) => {
  const inWriteMode = isWriteMode(mode);

  if (!inWriteMode) {
    return null;
  }

  return (
    <Box>
      <InputControl name="config.tailnetId" label="Tailnet ID" formHandle={formHandle} />

      <InputControl
        name="config.xAuthenticatedUserEnabled"
        label="Enable Tailnet Identity"
        formHandle={formHandle}
        type="switch"
      />
    </Box>
  );
};

export default TailscaleConnector;
